import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';
import { useDesignerStore } from '../../store/designerStore.js';

const GridWrapper = styled.div`
  width: 100%;
  min-height: 40px;
  
  ${props => !props.$isLiveMode && props.$isEmpty && `
    background: rgba(0, 169, 224, 0.03);
    border: 1px dashed rgba(0, 169, 224, 0.3);
    
    &::after {
      content: 'Leeres Grid (Spalten hier platzieren)';
      color: #718096;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  `}
`;

export function Grid({ node, children, isLiveMode }) {
  const addNode = useDesignerStore(state => state.addNode);
  const isDragging = useDesignerStore(state => state.isDragging);
  const isEmpty = !children || children.length === 0;

  const handleDragOver = (e) => {
    if (isLiveMode) return;
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  };

  const handleDrop = (e) => {
    if (isLiveMode) return;
    e.preventDefault();
    e.stopPropagation();
    
    const widgetType = e.dataTransfer.getData('tef-designer/widget-type');
    if (widgetType) {
      addNode(widgetType, node.id);
    }
  };

  return (
    <GridWrapper 
      $isLiveMode={isLiveMode} 
      $isEmpty={isEmpty}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      style={{
        boxShadow: (isDragging && !isLiveMode) ? 'inset 0 0 0 2px rgba(0, 169, 224, 0.3)' : 'none'
      }}
    >
      {children}
    </GridWrapper>
  );
}

registry.register('Grid', {
  label: 'Grid / Spalten',
  icon: '🔲',
  category: 'layout',
  component: Grid,
  defaultProps: {
    style: {
      desktop: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px',
        padding: '10px'
      }
    }
  },
  inspectorControls: [
    {
      tab: 'style',
      groups: [
        {
          title: 'Grid Layout',
          fields: [
            { name: 'style.desktop.gridTemplateColumns', type: 'text', label: 'Spalten (z.B. 1fr 1fr 1fr)' },
            { name: 'style.desktop.gap', type: 'text', label: 'Abstand Innen (Gap)' }
          ]
        }
      ]
    },
    {
      tab: 'advanced',
      groups: [
        {
          title: 'Abstände',
          fields: [
            { name: 'style.desktop.padding', type: 'text', label: 'Padding' },
            { name: 'style.desktop.margin', type: 'text', label: 'Margin' }
          ]
        }
      ]
    }
  ]
});
